import {directoryService} from "../services/directoryService";

const state = {
  directory: null,
};

const getters = {
  directory: (state) => state.directory,
};

const mutations = {
  setDirectory(state, directory) {
    state.directory = directory;
  },
};

const actions = {
  async getDirectory({commit, state}) {
    if (state.directory) return state.directory;

    const result = await directoryService.getDirectory();

    if (result?.directories?.length) {
      commit("setDirectory", result.directories[0]);
      return result.directories[0];
    }

    return null;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
